import { Expose } from 'class-transformer'
import { Entity } from '@/app/common/base/entity'

export class ProductPhase extends Entity<ProductPhase> {
    @Expose()
    code!: string

    @Expose()
    label!: string
}
